module.exports = __webpack_public_path__ + "img/75.244fa7ad.png";